import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function AiTrackerIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame {...props}>
      <path
        d="M40.95 22.75c-.618-8.363-7.337-15.082-15.7-15.7v3.51c6.441.6 11.59 5.749 12.19 12.19zm-18.2-15.7c-8.363.618-15.082 7.337-15.7 15.7h3.51c.6-6.441 5.749-11.59 12.19-12.19zm-15.7 18.2c.618 8.363 7.337 15.082 15.7 15.7v-3.51c-6.441-.6-11.59-5.749-12.19-12.19zm18.2 15.7c8.363-.618 15.082-7.337 15.7-15.7h-3.51c-.6 6.441-5.749 11.59-12.19 12.19z"
        fill={toolIconPrimary}
      />
      <path
        d="M24 16.5q1.125 6.375 7.5 7.5-6.375 1.125-7.5 7.5-1.125-6.375-7.5-7.5 6.375-1.125 7.5-7.5"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
